module.exports = __webpack_public_path__ + "static/media/yes-icon.ff47c1fe.svg";